import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
interface ExportGLBudgets {
  ExportCompanyIds: number[];
  fileType: number;
  tabs: number;
  startDate: string;
  endDate: string;
  exportType: number;
  amountType: number;
  allProperties: boolean;
}

const useExportGLBudgetsApi = () => {
  const call = useCallback(
    (params?: ExportGLBudgets) => axiosInstance.post(api.exportGLBudgets, params),
    []
  );
  const { execute, isLoading } = useAsync(call, false);

  return { exportExecute: execute, exportLoading: isLoading };
};

export default useExportGLBudgetsApi;
